module.exports = __webpack_public_path__ + "007958303bb3068799eeb4c3c5550ce8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-15.png
// module id = 1595
// module chunks = 0